export const getOrderCount = (state) => state.orders.length;
